import React, { useState } from 'react';
import { AssetUrls } from 'config/assets';

interface FeedCardImageProps {
  scryfallId?: string | null;
  name: string;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const FeedCardImage: React.FC<FeedCardImageProps> = ({
  scryfallId,
  name,
  className,
  onClick,
}) => {
  const [failed, setFailed] = useState(!scryfallId);

  if (failed || !scryfallId) {
    return (
      <div
        className={`feed-card-image feed-card-image--fallback ${className ?? ''}`}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        onClick={onClick}
        title={name}
      >
        <span>{name}</span>
      </div>
    );
  }

  return (
    <img
      src={AssetUrls.cards.getCardImage(scryfallId, 'normal')}
      alt={name}
      className={`feed-card-image ${className ?? ''}`}
      loading="lazy"
      onClick={onClick}
      onError={() => setFailed(true)}
    />
  );
};

export default FeedCardImage;
